import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gradient-to-r from-brand-orange to-brand-darkOrange text-white text-center py-3 px-5 font-semibold tracking-wide animate-pulse-opacity sticky top-0 z-50 text-[12px]" data-id="element-147">
      ⚡ OFERTA ESPECIAL DE LANZAMIENTO — PRECIO EXCLUSIVO POR TIEMPO LIMITADO
      ⚡
    </div>;
}